import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, makeStyles, tokens, Text, Card, CardHeader } from "@fluentui/react-components";
import { ArrowRight16Regular, Briefcase16Regular, DocumentArrowUp16Regular, Person16Regular } from "@fluentui/react-icons";
import PageHeader from "../../blocks/PageHeader";
import Container from "../../blocks/Container";
import Icon from "../../blocks/Icon";
import CVProcessor from "./CVProcessor";
import VacancyProcessor from "./VacancyProcessor";

const useStyles = makeStyles({
  title: {
    marginBottom: "14px",
    color: tokens.colorNeutralForeground1,
  },
  description: {
    marginBottom: "20px",
    color: tokens.colorNeutralForeground2,
  },
  card: {
    marginBottom: "10px",
  },
});

const DocumentPage = () => {
  const styles = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { uid, entity, document, skipPageHeader, selectedTab } = location.state || {};
  const [processingType, setProcessingType] = useState<"candidate" | "vacancy" | null>(null);

  const handleBack = () => {
    navigate(`/${entity.toLowerCase()}/${uid}`, { state: { skipPageHeader, selectedTab } });
  };

  const handleDocumentUpload = () => {
    navigate("/document-upload", { state: { uid, entity, document } });
  };

  return (
    <>
      <PageHeader onBack={handleBack} />

      {processingType === null ? (
        <Container>
          <Text className={styles.title} size={400} weight="bold" block>
            {document.name}
          </Text>

          <Text as="p" block className={styles.description}>
            Do you want to upload the document to the dossier or use it to create a new candidate?
          </Text>

          <Card orientation="horizontal" className={styles.card}>
            <CardHeader
              image={<Icon icon={<DocumentArrowUp16Regular />} size="medium" />}
              header={<Text>Upload document</Text>}
              action={<Button appearance="outline" icon={<ArrowRight16Regular />} onClick={handleDocumentUpload} />}
            />
          </Card>

          <Card orientation="horizontal" className={styles.card}>
            <CardHeader
              image={<Icon icon={<Person16Regular />} size="medium" />}
              header={<Text>New candidate</Text>}
              action={<Button appearance="outline" icon={<ArrowRight16Regular />} onClick={() => setProcessingType("candidate")} />}
            />
          </Card>

          <Card orientation="horizontal" className={styles.card}>
            <CardHeader
              image={<Icon icon={<Briefcase16Regular />} size="medium" />}
              header={<Text>New vacancy</Text>}
              action={<Button appearance="outline" icon={<ArrowRight16Regular />} onClick={() => setProcessingType("vacancy")} />}
            />
          </Card>
        </Container>
      ) : processingType === 'candidate' ? (
        <CVProcessor document={document} onFinish={() => setProcessingType(null)} />
      ) : (
        <VacancyProcessor document={document} onFinish={() => setProcessingType(null)} />
      )}
    </>
  );
};

export default DocumentPage;